import React from 'react'
import { 
  Card, 
  CardContent, 
  Typography, 
  TextField, 
  Button, 
  Box, 
  Grid, 
  IconButton 
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'

const Campuses = ({ 
  campuses, 
  handleAddCampus, 
  handleCampusChange, 
  handleRemoveCampus, 
  handleCampusesSubmit,
  setConfigStep,
  CONFIG_STEPS
}) => {
  const handleImageUpload = (campusId, event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        handleCampusChange(campusId, 'image', reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleRemoveImage = (campusId) => {
    handleCampusChange(campusId, 'image', '')
  }

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Hospital Campuses
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Add any additional campuses or locations for your hospital (optional)
        </Typography>
        
        {campuses.length > 0 ? (
          <Box sx={{ mb: 3 }}>
            {campuses.map((campus, index) => (
              <Card key={campus.id} sx={{ mb: 2, p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="subtitle1">
                    Campus {index + 1}
                  </Typography>
                  <IconButton 
                    size="small" 
                    color="error" 
                    onClick={() => handleRemoveCampus(campus.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
                
                <TextField
                  fullWidth
                  label="Campus Name"
                  value={campus.name}
                  onChange={(e) => handleCampusChange(campus.id, 'name', e.target.value)}
                  sx={{ mb: 2 }}
                />
                
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" gutterBottom>
                    Campus Photo
                  </Typography>
                  {campus.image ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <img 
                        src={campus.image} 
                        alt="Campus photo" 
                        style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }} 
                      />
                      <IconButton 
                        color="error" 
                        onClick={() => handleRemoveImage(campus.id)}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  ) : (
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                      sx={{ mb: 1 }}
                    >
                      Upload Photo
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => handleImageUpload(campus.id, e)}
                      />
                    </Button>
                  )}
                </Box>
                
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Campus Description"
                  value={campus.description}
                  onChange={(e) => handleCampusChange(campus.id, 'description', e.target.value)}
                  sx={{ mb: 2 }}
                />
                
                <TextField
                  fullWidth
                  label="Campus Address"
                  value={campus.address}
                  onChange={(e) => handleCampusChange(campus.id, 'address', e.target.value)}
                  sx={{ mb: 2 }}
                />
                
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="City"
                      value={campus.city}
                      onChange={(e) => handleCampusChange(campus.id, 'city', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="State"
                      value={campus.state}
                      onChange={(e) => handleCampusChange(campus.id, 'state', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            No campuses added yet. Click the button below to add a campus.
          </Typography>
        )}
        
        <Button
          startIcon={<AddIcon />}
          onClick={handleAddCampus}
          sx={{ mb: 3 }}
        >
          Add Campus
        </Button>
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            onClick={() => setConfigStep(CONFIG_STEPS.HOSPITAL_INFO)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleCampusesSubmit}
          >
            Continue
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default Campuses